import { render, staticRenderFns } from "./HpadN_Items.vue?vue&type=template&id=636b0006"
import script from "./HpadN_Items.vue?vue&type=script&lang=js"
export * from "./HpadN_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports